<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" routerLink="/administration/team-members/add">
        {{ 'authenticated.administration.team-members.create_btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<app-table id="dashboard.administration.team-members.index"></app-table>
